import request from './base/api';

/**
 * 取得會員訂閱列表 API
 * @param {Object} params - 包含 member_id 的物件
 * @param {function} cb - 成功回調函式
 * @param {function} errCb - 失敗回調函式
 */
export function getSubscriptions({ member_id }, cb, errCb) {
  return request({
    url: 'shopping/member/subscriptions',
    method: 'post',
    config: {
      data: {
        member_id
      }
    },
    cb,
    errCb
  });
}

/**
 * 會員取消訂閱 API
 * @param {number} subscriptionId - 訂閱 ID
 * @param {number} memberId - 會員 ID
 * @param {function} cb - 成功回調函式
 * @param {function} errCb - 失敗回調函式
 */
export function cancelSubscription(subscriptionId, memberId, cb, errCb) {
  return request({
    url: `shopping/subscription/${subscriptionId}/cancel`,
    method: 'post',
    config: {
      data: {
        member_id: memberId
      }
    },
    cb,
    errCb
  });
}

/**
 * 啟動更新付款卡片 API（扣款失敗的暫停訂閱，以新卡支付本期費用）
 * @param {number} subscriptionId - 訂閱 ID
 * @param {number} memberId - 會員 ID
 * @param {function} cb - 成功回調函式（回傳 mer_trade_no、redirect_token）
 * @param {function} errCb - 失敗回調函式
 */
export function startCardUpdate(subscriptionId, memberId, cb, errCb) {
  return request({
    url: `shopping/subscription/${subscriptionId}/update-card`,
    method: 'post',
    config: {
      data: {
        member_id: memberId
      }
    },
    cb,
    errCb
  });
}

export default {
  getSubscriptions,
  cancelSubscription,
  startCardUpdate
};
